import { Form, Spin } from 'antd'
import Button from 'components/Button'
import Control from 'components/Control/Control'
import AddIcon from 'components/icons/AddIcon'
import { v4 as uuidv4 } from 'uuid'
import EducationForm from 'modules/Onboarding/Register/EducationNew/EducationFormPartial'
import { educationDetails } from 'modules/Onboarding/Register/EducationNew/constant'
import { educationDetailsBefore } from 'modules/Onboarding/Register/EducationNew/constant'
import {
  AdjustIcon,
  LocalDiv,
  OptionWrapper,
  SelectLocalWrapper,
  Text,
  CurrentCourseWrapper
} from 'modules/Onboarding/Register/EducationNew/style'
import moment from 'moment'
import React, {
  Fragment,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import ErrorMessage from 'utils/ErrorMessage'
import SuccessMessage from 'utils/SuccessMessage'
import { searchConfig } from 'utils/config'
import { getBoardbyName, normalizeString } from '../../../../utils/helpers'
import { getStudentData } from '../../../Resume/actions'
import { boardList } from './constant'
import { getEducationLevelLabel } from '../../../../utils/const'
import { useTpoConfig } from '../../hooks/useTpoConfig'

const Education = ({
  setCurrent,
  studentData,
  studentFormData,
  updateStudentData,
  instituteName,
  deleteEducation,
  countryList,
  stateList,
  getListOfCountries,
  getListOfState,
  getListOfCity,
  getListOfSkills,
  activeKey,
  cvDetails,
  searchAPI,
  setActiveTab,
  updateCurrentState,
  registerForm,
  pendingData,
}) => {
  const dispatch = new useDispatch()
  const [form] = Form.useForm()
  const formRef = useRef()
  
  // Register this form with the parent component for stepper validation
  useEffect(() => {
    if (typeof registerForm === 'function') {
      // Modify the form to ensure it has proper submit handling
      const enhancedForm = {
        ...form,
        submit: () => {
          // Call the submitHandler function directly when submit is triggered
          submitHandler();
          return Promise.resolve();
        }
      };
      
      registerForm('education', enhancedForm);
      
      // Cleanup when component unmounts
      return () => registerForm('education', null);
    }
  }, [form, registerForm])
  const { Option } = SelectLocalWrapper
  const [education, setEducation] = useState([])
  const [educationList, setEducationList] = useState([])
  const [updatedList, setUpdatedList] = useState([])
  const [universityName, setUniversityName] = useState('')
  const [universitySearchList, setUniversitySearchList] = useState([])
  const [searchState, setSearchState] = useState('')
  const [refreshKey, setRefreshKey] = useState(1)
  const [skillLoading, setSkillLoading] = useState(true)
  const [stateId, setStateId] = useState('')
  const [locationData, setLocationData] = useState({
    stateId: '',
    state: '',
    cityId: '',
    city: '',
  })
  const [cityId, setCityId] = useState('')
  const [examType, setExamType] = useState('')
  const [duration, setDuration] = useState('')
  const [loading, setLoading] = useState(true)
  const [loadingState, setLoadingState] = useState(false)
  const [loadingCity, setLoadingCity] = useState(false)
  const [instituteCampusName, setInstituteCampusName] = useState('')
  const [universityId, setUniversityId] = useState('')
  const [instituteId, setInstituteId] = useState('')
  const [submitLoading, setSubmitLoading] = useState(false)
  const [updated, setUpdated] = useState(false)
  const [shown, setShown] = useState([])

  const [currentInstituteId, setCurrentInstituteId] = useState(
    studentFormData?.student?.instituteCampusId
      ? studentFormData?.student?.instituteCampusId
      : null
  )
  const [currentInstituteName, setCurrentInstituteName] = useState(
    studentFormData?.student?.instituteCampusName
      ? studentFormData?.student?.instituteCampusName
      : null
  )
  const [searchCollege, setSearchCollege] = useState('')
  const [listOfAddedSkills, setListOfAddedSkills] = useState([])

  const [allSkills, setAllSkills] = useState([])

  const { frozenFields } = useTpoConfig(
    studentFormData?.student?.instituteCampusId,
    studentFormData
  )

  const SkillsAPI = async search => {
    try {
      const results = await searchAPI(
        searchConfig?.skills?.name,
        search,
        searchConfig?.skills
      )
      let updatedSkills = results || []
      const newSkill = {
        name: search,
        id: Math.random().toString(36).substr(2, 8),
      }
      if (updatedSkills.length === 0 && search) {
        setListOfAddedSkills(prev => [...prev, newSkill])
        updatedSkills = [newSkill, ...updatedSkills]
      }

      const isExactMatch = updatedSkills.some(
        skill => skill?.name.toLowerCase() === search?.toLowerCase()
      )
      if (updatedSkills.length > 0) {
        if (!isExactMatch && search?.length > 3) {
          setListOfAddedSkills(prev => [...prev, newSkill])
          updatedSkills = [newSkill, ...updatedSkills]
        } else {
          updatedSkills = updatedSkills
        }
      }

      if (!allSkills?.length) {
        setAllSkills(updatedSkills)
      }
      setSkillLoading(false)
      return updatedSkills
    } catch (error) {
      setSkillLoading(false)

      console.error(`Error searching ${searchConfig?.skills?.name}:`, error)
    }
  }

  useLayoutEffect(() => {
    searchAPI(searchConfig?.universities?.name, '', searchConfig?.universities)
      .then(results => setUniversitySearchList(results))
      .catch(error =>
        console.error(
          `Error searching ${searchConfig?.universities?.name}:`,
          error
        )
      )
    SkillsAPI()
  }, [])

  const universityList = useSelector(
    state => state?.studentData?.universityList
  )
  const AllCollegeList = useSelector(state => state?.resumeData?.AllCollegeList)
  const CollegeList = useSelector(state => state?.resumeData?.CollegeList)
  useLayoutEffect(() => {
    let educationData = educationList
    
    let educationsList = []
    let tenth = false
    let twelfth = false
    educationData?.forEach(data => {
      let educationLevel = data.educationLevel?.toLowerCase()
      // Don't modify educationLevel - keep original values for API compatibility
      if (educationLevel === 'tenth' || educationLevel === 'hsc') {
        tenth = true
      }
      if (
        educationLevel === 'twelfth' ||
        educationLevel === 'sslc' ||
        educationLevel === 'diploma' ||
        educationLevel === 'puc'
      ) {
        twelfth = true
      }
    })

    if (!tenth) {
      educationsList.push({
        component: EducationForm,
        level: 'tenth',
        label: '10th',
        type: true,
      })
    }
    // if (!twelfth) {
    //   educationsList.push({
    //     component: EducationForm,
    //     level: 'twelfth',
    //     label: '12th',
    //     type: true,
    //   })
    // }
    educationData
      ?.filter(item => item?.educationLevel)
      ?.map(data => {
        let educationLevel = data.educationLevel?.toLowerCase()
        let type =
          educationLevel === 'tenth' ||
          (educationLevel === 'twelfth') | (educationLevel === 'hsc') ||
          educationLevel === 'sslc'
        let level = getEducationLevelValue(
          educationLevel != '' ? educationLevel : 'ug',
          true,
          educationsList
        )

        let board = boardList[boardList?.length - 1]?.name
        if (type && data?.board) {
          let actucallBoardName = getBoardbyName(boardList, data?.board)
          if (actucallBoardName) {
            board = actucallBoardName?.name
          } else {
            const normalizedBoardName = normalizeString(data?.board || '')
            let boardName = getBoardbyName(boardList, normalizedBoardName)
            if (boardName) {
              board = boardName?.name
            }
          }
        }
        let initialFields = {
          educationLevel: level,
          university: data?.university,
          universityId: data?.universityId,
          institutionId: data?.institutionId,
          institutionName: type ? '' :  data?.institutionName,
          collegeName:  type ? '' :  data?.collegeName,
          collegeId: data?.collegeId,
          board,
          degree: data?.degree,
          department: data?.department,
          specialisation: data?.specialisation,
          degreeStreamMapId: data?.degreeStreamMapId,
          degreeId: data?.degreeId,
          streamId: data?.streamId,
          specialisationId: data?.specialisationId,
          // startedOn:
          //   data?.startedOn > 0
          //     ? moment(parseInt(data?.startedOn)).format('MM/YYYY')
          //     : null,
          endedOn:
            data?.endedOn > 0
              ? moment(parseInt(data?.endedOn)).format('MM/YYYY')
              : null,
           endedYear:
                      data?.endedOn > 0
                        ? moment(parseInt(data?.endedOn)).format('YYYY')
                        : null,    
          marks: data?.marks ? parseFloat(data?.marks).toFixed(2) : null,
          averageMarks: data?.averageMarks ? parseFloat(data?.averageMarks).toFixed(2) : null,
          noOfArrears: data?.noOfArrears,
          historyOfArrears: data?.historyOfArrears,
          state: data?.state,
          stateId: data?.stateId,
          city: data?.city,
          cityId: data?.cityId,
          skills: data?.skills || [],
          awards: data?.awards,
          domain: data?.domain,
          domainId: data?.domainId,
          isDelete: false,
        }

        let educationListObj = {
          component: EducationForm,
          level: level,
          label: getEducationLevelLabel(data?.educationLevel),
          type: type,
          isCurrentCourse: !!data?.isCurrentCourse,
        }
        if (data?.degreeStreamMapId) {
          initialFields.degreeStreamMapId = data?.degreeStreamMapId
        }
        if (data?.tcUrl?.url) {
          initialFields.tcUrl = data?.tcUrl
        }
        if (data?.markSheetUrl?.url) {
          initialFields.markSheetUrl = data?.markSheetUrl
        }
        if (data?.id) {
          initialFields.id = data?.id
          educationListObj.id = data?.id
        }
        form.setFieldsValue({
          [level]: initialFields,
        })
        return educationsList.push(educationListObj)
      })
    setUpdatedList(educationsList)
    setEducation(educationsList)

    setTimeout(() => {
      setLoading(false)
    }, 2000)
  }, [educationList])

  const subjectHandler = (educationLevel, option) => {
    setStateId('')
    setCityId('')
    setRefreshKey(refreshKey + 1)
    let arr = []
    let type =
      option?.value === 'tenth' ||
      option?.value === 'twelfth' ||
      option?.value === 'hsc' ||
      option?.value === 'sslc' ||
      option?.value === 'ug'
    arr.push({
      component: EducationForm,
      level: option?.value,
      label: option?.label,
      type: type,
    })
    let levelsList = updatedList?.map(data => data?.level)
    if (educationLevel !== true && !levelsList.includes(educationLevel))
      return (
        setEducation(edu => edu.concat(arr)),
        setUpdatedList(edu => edu.concat(arr))
      )
  }

  const getEducationLevelValue = (value, isUpdate = false, educationsList) => {
    if (value === 'currentCourse') {
      return 'currentCourse'
    } else if (
      value === 'diploma' ||
      value === 'p_g_diploma' ||
      value === 'ug' ||
      value === 'pg' ||
      value === 'phd'
    ) {
      let list = (isUpdate ? educationsList : education)?.filter(data =>
        data?.level?.includes(value)
      )
      if (value === 'ug') {
        return 'ug' + '_' + list?.length
      } else if (value === 'diploma') {
        return 'diploma' + '_' + list?.length
      } else if (value === 'pg') {
        return 'pg' + '_' + list?.length
      } else if (value === 'phd') {
        return 'phd' + '_' + list?.length
      } else if (value === 'p_g_diploma') {
        return 'p_g_diploma' + '_' + list?.length
      }
    } else {
      return value
    }
  }

  const getAddedLevel = value => {
    let levelsList = updatedList?.map(data => data?.level)

    if (
      value === 'diploma' ||
      value === 'p_g_diploma' ||
      value === 'ug' ||
      value === 'pg' ||
      value === 'phd'
    ) {
      return true
    } else {
      return levelsList.includes(value)
    }
  }
  // const onRemoveEducation = async (deleteLevel, educationId) => {
  //   // Apply the exact same logic as the resume education section
  //   let updatedListData = updatedList?.filter(
  //     data => data?.level !== deleteLevel
  //   )
  //   if (educationId) {
  //     SuccessMessage('Deleted successfully!')
  //     form.setFieldsValue({
  //       [deleteLevel]: '',
  //     })
  //     const newDeleteLevel = deleteLevel + 'deleted'
  //     form.setFieldsValue({
  //       [newDeleteLevel]: { id: educationId, isDelete: true },
  //     })
  //     setUpdatedList(updatedListData)
  //   } else {
  //     form.setFieldsValue({
  //       [deleteLevel]: undefined,
  //     })
  //     setUpdatedList(updatedListData)
  //   }
  // }

 const onRemoveEducation = async (deleteLevel, educationId) => {
  console.log(updatedList,'updatedList',deleteLevel,educationId)
    let updatedListData = updatedList?.filter(
      data => data?.level !== deleteLevel
    )
    console.log(updatedListData,'updatedList',deleteLevel,educationId)
    if (educationId) {
      SuccessMessage('Deleted successfully!')
      form.setFieldsValue({
        [deleteLevel]: '',
      })
      const newDeleteLevel = deleteLevel + 'deleted'
      form.setFieldsValue({
        [newDeleteLevel]: { id: educationId, isDelete: true },
      })
      setUpdatedList(updatedListData)
      // return setEducation(updatedList)
    } else {
      form.setFieldsValue({
        [deleteLevel]: undefined,
      })
      setUpdatedList(updatedListData)

      //return setEducation(updatedList)
    }
  }


  useEffect(() => {
    let getData
    getData = setTimeout(() => {
      getListOfState('', searchState, false, setLoadingState)
    }, 500)
    return () => clearTimeout(getData)
  }, [searchState])

  // Sync education state with updatedList to ensure UI renders all added educations
  // useEffect(() => {
  //   setEducation(updatedList)
  // }, [updatedList])

  useLayoutEffect(() => {
    if (educationList.length > 0) {
      return
    }

    let currentCourseData = studentFormData?.currentCourse
    
    let cvEducationDetails = cvDetails?.education || []
    let cvCurrentCourse = cvDetails?.currentCourse
    let averageMarks =
      currentCourseData?.averageMarks > 0
        ? currentCourseData?.averageMarks
        : cvCurrentCourse?.averageMarks

    setExamType(currentCourseData?.examType)
    setDuration(currentCourseData?.duration)
    
    // Process pending data for currentCourse
    const pendingCurrentCourse = pendingData?.currentCourse
    let currentCourseRequestId = null
    let pendingFieldsForCurrentCourse = null
    
    if (pendingCurrentCourse) {
      if (pendingCurrentCourse._pendingFields) {
        // Handle structured format with _pendingFields
        const firstFieldKey = Object.keys(pendingCurrentCourse._pendingFields)[0]
        if (firstFieldKey && pendingCurrentCourse._pendingFields[firstFieldKey]._requestId) {
          currentCourseRequestId = pendingCurrentCourse._pendingFields[firstFieldKey]._requestId
        }
        pendingFieldsForCurrentCourse = pendingCurrentCourse._pendingFields
      } else {
        // Handle direct format where pending data is on the object itself
        const pendingFieldsMap = {}
        Object.keys(pendingCurrentCourse).forEach(fieldName => {
          // GET /students/:id/pending-data always returns a currentCourse scaffold of
          // six explicit nulls (averageMarks, noOfArrears, historyOfArrears,
          // university, specialisation, marks) whether or not anything is actually
          // awaiting approval. Accepting null here minted a pending entry for each of
          // them — and a 'pending' _requestId — so every student saw the verification
          // icon on those fields. A null is the absence of a pending change.
          if (fieldName !== 'id' && fieldName !== 'isCurrentCourse' && pendingCurrentCourse[fieldName] !== undefined && pendingCurrentCourse[fieldName] !== null) {
            let fieldValue = pendingCurrentCourse[fieldName]
            
            // Handle nested specialisation object
            if (fieldName === 'specialisation' && typeof fieldValue === 'object' && fieldValue !== null) {
              if (fieldValue.specialisation) {
                pendingFieldsMap.specialisation = { value: fieldValue.specialisation }
                if (fieldValue.specialisationId) {
                  pendingFieldsMap.specialisationId = { value: fieldValue.specialisationId }
                }
              }
            } else if (fieldName === 'university' && typeof fieldValue === 'object' && fieldValue !== null) {
              if (fieldValue.university) {
                pendingFieldsMap.university = { value: fieldValue.university }
                if (fieldValue.universityId) {
                  pendingFieldsMap.universityId = { value: fieldValue.universityId }
                }
              }
            } else {
              pendingFieldsMap[fieldName] = { value: fieldValue }
            }
          }
        })
        if (Object.keys(pendingFieldsMap).length > 0) {
          pendingFieldsForCurrentCourse = pendingFieldsMap
          currentCourseRequestId = 'pending'
        }
      }
    }
    
    let currentCourse = {
      id: currentCourseData?.id,
      isCurrentCourse: true,
      university: currentCourseData?.university,
      universityId: currentCourseData?.universityId,
      educationLevel: currentCourseData?.educationLevel,
      collegeName: studentFormData?.student?.instituteCampusName,
      collegeId: studentFormData?.student?.instituteCampusId,
      board: '',
      degree: currentCourseData?.degree,
      department: currentCourseData?.department,
      specialisation: currentCourseData?.specialisation,
      degreeStreamMapId: currentCourseData?.degreeStreamMapId,
      degreeId: currentCourseData?.degreeId,
      streamId: currentCourseData?.streamId,
      specialisationId: currentCourseData?.specialisationId,
      startedOn: currentCourseData?.startedOn,
      endedOn: currentCourseData?.endedOn,
       endedYear:
       currentCourseData?.endedOn > 0
                    ? moment(parseInt(currentCourseData?.endedOn)).format('YYYY')
                    : null,
      skills: currentCourseData?.skills || [],
      averageMarks: currentCourseData?.averageMarks
      ? currentCourseData?.averageMarks
      : 0,
    marks: currentCourseData?.averageMarks ? currentCourseData?.averageMarks : 0,
      state: currentCourseData?.state || '',
      stateId: currentCourseData?.stateId || '',
      city: currentCourseData?.city || '',
      cityId: currentCourseData?.cityId || '',
      noOfArrears: currentCourseData?.noOfArrears,
      historyOfArrears: currentCourseData?.historyOfArrears,
      domain: currentCourseData?.domain,
      domainId: currentCourseData?.domainId,
      _requestId: currentCourseRequestId,
      _pendingFields: pendingFieldsForCurrentCourse,
    }
    
    // Merge pending values into currentCourse
    if (pendingFieldsForCurrentCourse) {
      // First pass: merge all non-null values
      Object.keys(pendingFieldsForCurrentCourse).forEach(fieldName => {
        const pendingValue = pendingFieldsForCurrentCourse[fieldName].value
        if (pendingValue !== null) {
          currentCourse[fieldName] = pendingValue
        }
      })
      
      // Second pass: sync marks and averageMarks
      if (pendingFieldsForCurrentCourse.averageMarks?.value !== null && pendingFieldsForCurrentCourse.averageMarks?.value !== undefined) {
        currentCourse.marks = pendingFieldsForCurrentCourse.averageMarks.value
        currentCourse.averageMarks = pendingFieldsForCurrentCourse.averageMarks.value
      } else if (pendingFieldsForCurrentCourse.marks?.value !== null && pendingFieldsForCurrentCourse.marks?.value !== undefined) {
        currentCourse.averageMarks = pendingFieldsForCurrentCourse.marks.value
        currentCourse.marks = pendingFieldsForCurrentCourse.marks.value
      }
    }
    
    let educations =  studentFormData?.education
    
    console.log('Initial educations:', educations)
    
    let pendingEducation = pendingData?.education || []
    
    console.log('pendingData?.education:', pendingData?.education)
    console.log('pendingData?.requests:', pendingData?.requests)
    
    if (pendingData?.requests && Array.isArray(pendingData.requests)) {
      const pendingRequests = pendingData.requests
      const educationPendingMap = new Map()
      
      pendingRequests.forEach(request => {
        if (request.status !== 'PENDING') return
        
        if (request.fieldName === 'otherEducation' && request.itemId && request.isNewItem) {
          educationPendingMap.set(request.itemId, {
            _isNew: true,
            _requestId: request.id,
            _pendingFields: {},
            id: request.itemId,
            ...request.requestedData
          })
        }
        else if (request.fieldName?.startsWith('education.') && request.itemId) {
          if (!educationPendingMap.has(request.itemId)) {
            educationPendingMap.set(request.itemId, { _pendingFields: {} })
          }
          const fieldName = request.fieldName.replace('education.', '')
          educationPendingMap.get(request.itemId)._pendingFields[fieldName] = {
            value: request.requestedData,
            originalValue: request.originalData,
            status: request.status,
            _requestId: request.id
          }
        }
      })
      
      pendingEducation = Array.from(educationPendingMap.entries()).map(([itemId, data]) => ({
        ...data,
        id: itemId
      }))
      
      console.log('Processed pendingEducation from requests:', pendingEducation)
    }
    
    console.log('Final pendingEducation array:', pendingEducation)
    
    if (pendingEducation.length > 0) {
      educations = educations.map(approved => {
        const pending = pendingEducation.find(
          p => p.id === approved.id || p._itemId === approved.id
        )
        if (pending && pending._pendingFields) {
          const merged = { ...approved }
          
          // Extract requestId from first pending field
          let requestId = null
          const firstFieldKey = Object.keys(pending._pendingFields)[0]
          if (firstFieldKey && pending._pendingFields[firstFieldKey]._requestId) {
            requestId = pending._pendingFields[firstFieldKey]._requestId
          }
          
          // Merge only the VALUES from pending fields, not the entire pending object
          Object.keys(pending._pendingFields).forEach(fieldName => {
            merged[fieldName] = pending._pendingFields[fieldName].value
          })
          
          merged._pendingFields = pending._pendingFields
          merged._requestId = requestId
          
          return merged
        }
        return approved
      })
      
      console.log('After merging pending fields into approved:', educations)
      
      const newPendingEducation = pendingEducation.filter(
        p => p._isNew || !educations.find(a => a.id === p.id || a.id === p._itemId)
      )
      
      console.log('New pending education to add:', newPendingEducation)
      
      educations = [...educations, ...newPendingEducation]
      
      console.log('Final educations after adding new pending:', educations)
    }
    
    // Only use CV education data if there's no actual education data AND no pending education data
    if (!studentFormData?.education?.length && !pendingEducation?.length && cvEducationDetails?.length) {
      const modifiedEducationDetails = cvEducationDetails
        ?.filter(item => item?.educationLevel)
        ?.map((data, index) => {
          if (/^\d{4}$/.test(data?.endedOn.toString())) {
            data.endedOn = `01/${data?.endedOn}`
          }
          if (moment(data?.endedOn, 'MM/YYYY').isValid()) {
            data.endedOn = data.endedOn
              ? moment(data?.endedOn, 'MM/YYYY').format('x')
              : null
          }
          if (/^\d{4}$/.test(data?.startedOn.toString())) {
            data.startedOn = `01/${data?.startedOn}`
          }
          if (moment(data?.startedOn, 'MM/YYYY').isValid()) {
            data.startedOn = data.startedOn
              ? moment(data?.startedOn, 'MM/YYYY').format('x')
              : null
          }

          return data
        })
      educations = modifiedEducationDetails
    }
    
    // Add current course after CV education check to ensure it's not lost
    if (currentCourseData && !educations.find(edu => edu.id === currentCourseData.id)) {
      educations = [...educations, { ...currentCourse, educationLevel: currentCourseData?.educationLevel }]
    }
    
    if (!studentData?.isExpCandidate) {
      let educationList = educations || []

      const twelfthEntries = educationList.filter(edu => edu?.educationLevel === "twelfth" && !edu?.isCurrentCourse);
      if (twelfthEntries.length > 1) {
        // Sort twelfth entries by endedOn date
        twelfthEntries.sort((a, b) => {
          const endedA = moment(parseInt(a?.endedOn));
          const endedB = moment(parseInt(b?.endedOn));
          if (!endedA.isValid() || !endedB.isValid()) return 0;
          return endedB.valueOf() - endedA.valueOf();
        });
        // Keep only the most recent twelfth entry
        const mostRecentTwelfth = twelfthEntries[0];
        educationList = educationList.filter(edu => 
          edu?.educationLevel !== "twelfth" || edu?.isCurrentCourse || edu === mostRecentTwelfth
        );
      }

      educationList?.sort((a, b) => {
        const endedA = moment(parseInt(a?.endedOn))
        const endedB = moment(parseInt(b?.endedOn))

        // Check if both dates are valid
        if (!endedA.isValid() || !endedB.isValid()) {
          return 0
        }

        // Sort by the "ended_in" date in descending order
        if (endedB.isAfter(endedA)) return 1
        if (endedA.isAfter(endedB)) return -1
        return 0
      })

      setEducationList(educationList)
    } else if (studentData?.isExpCandidate) {
      let educationList = educations

      const twelfthEntries = educationList.filter(edu => edu?.educationLevel === "twelfth" && !edu?.isCurrentCourse);
      if (twelfthEntries.length > 1) {
        twelfthEntries.sort((a, b) => {
          const endedA = moment(parseInt(a?.endedOn));
          const endedB = moment(parseInt(b?.endedOn));
          if (!endedA.isValid() || !endedB.isValid()) return 0;
          return endedB.valueOf() - endedA.valueOf();
        });
        const mostRecentTwelfth = twelfthEntries[0];
        educationList = educationList.filter(edu => 
          edu?.educationLevel !== "twelfth" || edu?.isCurrentCourse || edu === mostRecentTwelfth
        );
      }

      educationList?.sort((a, b) => {
        const endedA = moment(parseInt(a?.endedOn))
        const endedB = moment(parseInt(b?.endedOn))

        // Check if both dates are valid
        if (!endedA.isValid() || !endedB.isValid()) {
          return 0
        }

        // Sort by the "ended_in" date in descending order
        if (endedB.isAfter(endedA)) return 1
        if (endedA.isAfter(endedB)) return -1
        return 0
      })
      setEducationList(educationList)
    }
  }, [studentFormData, pendingData])

  const getEducationLevel = level => {
    let name = level?.replaceAll('_', '')
    return name?.replace(/\d/g, '')
  }

  const getEducationLevelSearch = level => {
    let name = level?.replaceAll('_', '')
    let result = name?.replace(/\d/g, '')
    return result === 'pgdiploma'
      ? 'P_G_DIPLOMA'
      : result === 'pd'
      ? 'PHD'
      : result?.toUpperCase()
  }

  const getEducationLevel1 = level => {
    let name = level?.replaceAll('_', '')
    return name === 'pgdiploma'
      ? 'p_g_diploma'
      : name?.replace(/\d/g, '')?.toLowerCase()
  }
  const uuidRegex =
    /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i
  const submitHandler = async () => {
    setSubmitLoading(true)
    let values = await form.getFieldValue()
    
    const errorList = []
    await form
      .validateFields()
      .then()
      .catch(err => {
        errorList.push(err?.errorFields)
      })
    if (!errorList?.length) {
      let educationList = []
      let educationDeleteList = []
      let currentCourse = []
      let tenth = false
      let twelth = false
      let diploma = false
      let under = false
      const convertedData = Object.keys(values).reduce((acc, key) => {
        if (
          key.includes('ug_') ||
          key.includes('pg_') ||
          key.includes('diploma_') ||
          key.includes('phd_') ||
          key.includes('p_g_diploma')
        ) {
          const [name, award] = key.split('award+')
          const value = values[key]
          if (!acc[name]) {
            acc[name] = {
              ...value,
              awards: [],
            }
          }
          if (key.includes('award+')) acc[name].awards.push({ ...value })
        } else {
          acc[key] = values[key]
        }
        return acc
      }, {})

     Object.values(convertedData)?.forEach(data => {
              if (data?.isDelete) {
                educationDeleteList.push(data?.id)
              } else if (data?.noOfArrears >= 0) {
               currentCourse.push({
                 ...data,
                 averageMarks: data?.marks ? data?.marks : 0,
                 educationLevel: studentFormData?.currentCourse?.educationLevel,
                 startedOn: studentFormData?.currentCourse?.startedOn,
                 endedOn: data?.endedYear
                 ? studentFormData?.currentCourse?.endedOn
                 : null,
                 skills:
                 data?.skills?.map(skill => ({
                   id: /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(
                     skill.id
                   )
                     ? skill.id
                     : '',
                   name: skill.name,
                 })) || [],
                 university: data?.university || null,
                 universityId: data?.universityId || null,
                 historyOfArrears: data?.historyOfArrears || 0,
                 specialisationId: Array.isArray(data?.specialisationId) ? data?.specialisationId.join(',') : data?.specialisationId ?? '',
                 markSheetUrl: data?.markSheetUrl || {},
                 tcUrl: data?.tcUrl || {},
             })
              } else if (data?.marks) {
                const educationItem = {
                  ...data,
                  temp_id: data?.id ? data?.temp_id : (data?.temp_id || `temp-${uuidv4()}`),
                  state: data?.state || '',
                  stateId: data?.stateId || '',
                  city: data?.city || '',
                  cityId: data?.cityId || '',
                  educationLevel: getEducationLevel1(data?.educationLevel),
                  endedOn: data?.endedYear
                    ? moment(data?.endedYear, 'YYYY').format('x')
                    : null,
                  startedOn: data?.startedYear
                    ? moment(data?.startedYear, 'YYYY').format('x')
                    : null,
                  skills:
                    data?.skills?.map(skill => ({
                      id: uuidRegex.test(skill.id) ? skill.id : '',
                      name: skill.name,
                    })) || [],
                  ...(data?.tcUrl ? { tcUrl: data.tcUrl } : {}),
                  ...(data?.markSheetUrl ? { markSheetUrl: data.markSheetUrl } : {}),
                  university: data?.university || null,
                  historyOfArrears: data?.historyOfArrears || 0,
                  specialisationId: Array.isArray(data?.specialisationId)
                    ? data?.specialisationId.join(',')
                    : data?.specialisationId ?? '',
                }
      
                educationList.push(educationItem)
      
                // Track education levels
                const level = data?.educationLevel?.toLowerCase()
                if (level === 'tenth') tenth = true
                if (level === 'twelfth' || level === 'sslc' || level === 'diploma') {
                  if (level === 'diploma') diploma = true
                  else twelth = true
                }
              }
            })
      
      let payload = {
        checkForApproval: true,
        checkDeleteSection: ['education'],
        fieldsRequiringApproval: ['education.markSheetUrl', 'education.tcUrl', 'currentCourse.markSheetUrl', 'currentCourse.tcUrl'],
        admin: {
          ...studentFormData?.admin,
          countryCode: studentFormData?.admin?.countryCode,
        },
        student: {
          ...studentFormData?.student,
          instituteCampusId: currentInstituteId,
          instituteCampusName: currentInstituteName,
        },
        studentPersonalProfile: studentFormData?.studentPersonalProfile,
        currentCourse: !studentData?.isExpCandidate
          ? { ...studentFormData?.currentCourse, ...currentCourse[0] }
          : {},
        education: educationList.map(educationItem => ({
          ...educationItem,
        })),
        resume: studentFormData?.resume,
        degreeStreamMap: !studentFormData?.student?.isExpCandidate
          ? {
              degreeId: currentCourse[0]?.degreeId,
              streamId: currentCourse[0]?.streamId,
            }
          : {},
          checkForApproval: true,
          checkDeleteSection: ["education"],
        }
      delete payload?.currentCourse?.startMonth
      delete payload?.currentCourse?.startYear
      delete payload?.currentCourse?.endMonth
      delete payload?.currentCourse?.endYear

      payload?.education.map((item, index) => {
        delete payload?.education[index]?.startMonth
        delete payload?.education[index]?.startYear
        delete payload?.education[index]?.endMonth
        delete payload?.education[index]?.endYear

        return null
      })

      if (payload?.currentCourse?.specialisationId === null) {
        delete payload?.currentCourse?.specialisationId
      }
      if (payload?.studentPersonalProfile?.secondaryEmail === null) {
        delete payload?.studentPersonalProfile?.secondaryEmail
      }
      if (
        payload?.currentCourse?.degreeStreamMapId === null ||
        !payload?.currentCourse?.degreeStreamMapId
      ) {
        delete payload?.currentCourse?.degreeStreamMapId
      }

      payload?.education.map((item, index) => {
        if (item?.skills === null || item?.skills == '')
          delete payload?.education[index]?.skills
        if (!item?.degreeStreamMapId)
          delete payload?.education[index]?.degreeStreamMapId
        return null
      })
      educationList?.map((value, index) => {
        for (const [key, value1] of Object.entries(value)) {
          if (key === 'educationLevel' && value1 === 'tenth') {
            tenth = true
          }
          if (key === 'educationLevel' && value1 === 'twelfth') {
            twelth = true
          }
          if (key === 'educationLevel' && value1 === 'diploma') {
            diploma = true
          }
          if (key === 'educationLevel' && value1 === 'ug') {
            under = true
          }
        }
        return null
      })

      currentCourse?.map((value, index) => {
        for (const [key, value1] of Object.entries(value)) {
          if (
            (key === 'educationLevel' && value1 === 'ug') ||
            (key === 'educationLevel' && value1 === 'UG')
          ) {
            under = true
          }
          if (key === 'educationLevel' && value1 === 'diploma') {
            diploma = true
          }
        }
        return null
      })
      if (tenth && checkMandatory(twelth, diploma)) {
        let response = await updateStudentData(payload)
        
        if (response?.success === true) {
          //await (updateCurrentState(studentData?.id, 4))
          await dispatch(getStudentData())
          
          if (educationDeleteList?.length > 0) {
            educationDeleteList.map(async item => {
              await deleteEducation(item)
            })
          }
          
          SuccessMessage('Education details saved successfully!')
          setSubmitLoading(false)
       
          setUpdated(true)
          setActiveTab('project')
        } else {
          setSubmitLoading(false)

          ErrorMessage(response?.response?.data?.message)
        }
      } else if (!tenth && checkMandatory(twelth, diploma)) {
        setSubmitLoading(false)

        ErrorMessage('10th is Mandatory')
      } else if (tenth && !checkMandatory(twelth, diploma)) {
        setSubmitLoading(false)

        ErrorMessage('12th or Diploma is Mandatory')
      } else if (!tenth && !checkMandatory(twelth, diploma)) {
        setSubmitLoading(false)
        ErrorMessage('10th And 12th or Diploma is Mandatory')
      }
    } else {
      const errorForms = []
      errorList.map(item => {
        item.map(innerItem => {
          if (!errorForms.includes(innerItem?.name[0][0])) {
            errorForms.push(innerItem?.name[0][0])
          }
        })
      })
      const updatedValues = {}
      Object.keys(values).forEach(key => {
        if (errorForms.includes(key)) {
          updatedValues[key] = {
            ...values[key],
            shown: true,
          }
        } else {
          updatedValues[key] = {
            ...values[key],
          }
        }
      })
      form.setFieldsValue(updatedValues)
      setShown(errorForms)
      setSubmitLoading(false)
    }
  }

  const checkMandatory = (twelth, diploma) => {
    return twelth === true || diploma === true
  }
  const scrollToFirstError = errors => {
    const firstErrorField = errors?.[errors?.length - 1]
    if (firstErrorField) {
      const firstErrorField1 = firstErrorField.name.join('.')
      formRef.current.scrollToField(firstErrorField1)
    }
  }

  const handleBackClick = () => {
    setActiveTab('personal')
  }
  return (
    <Fragment>
      {!loading && !skillLoading ? (
        <Form
          scrollToFirstError
          onFinish={submitHandler && !updated}
          id={'educationForm'}
          form={form}
          layout="vertical"
          ref={formRef}
          onFinishFailed={({ errorFields }) => {
            scrollToFirstError(errorFields)
          }}
        >
         {education?.length > 0 &&
                    education?.map((type, index) => (
                      <type.component
                        form={form}
                        key={index + 'type'}
                        level={type?.level}
                        label={type?.label}
                        isType={type?.type}
                        onRemoveEducation={onRemoveEducation}
                        universitySearchList={universitySearchList}
                        setUniversitySearchList={setUniversitySearchList}
                        getEducationLevelSearch={getEducationLevelSearch}
                        isCurrentCourse={type?.isCurrentCourse}
                        studentFormData={studentData}
                        getEducationLevel={getEducationLevel}
                        educationId={type?.id}
                        stateId={stateId}
                        setStateId={setStateId}
                        setCityId={setCityId}
                        cityId={cityId}
                        setLocationData={setLocationData}
                        locationData={locationData}
                        universityValue={universityName}
                        setUniversityName={setUniversityName}
                        universityList={universityList}
                        stateList={stateList}
                        getListOfCountries={getListOfCountries}
                        getListOfState={getListOfState}
                        getListOfCity={getListOfCity}
                        examType={examType}
                        duration={duration}
                        setExamType={setExamType}
                        setDuration={setDuration}
                        setSearchState={setSearchState}
                        AllCollegeList={AllCollegeList}
                        setInstituteCampusName={setInstituteCampusName}
                        instituteCampusValue={instituteCampusName}
                        universityId={universityId}
                        setUniversityId={setUniversityId}
                        insttituteId={instituteId}
                        setInstituteId={setInstituteId}
                        getListOfSkills={getListOfSkills}
                        setCurrentInstituteName={setCurrentInstituteName}
                        setCurrentInstituteId={setCurrentInstituteId}
                        CollegeList={CollegeList}
                        setSearchCollege={setSearchCollege}
                        searchCollege={searchCollege}
                        loadingCity={loadingCity}
                        loadingState={loadingState}
                        setLoadingCity={setLoadingCity}
                        setLoadingState={setLoadingState}
                        skillLoading={skillLoading}
                        setSkillLoading={setSkillLoading}
                        searchAPI={searchAPI}
                        SkillsAPI={SkillsAPI}
                        allSkills={allSkills}
                        education={education}
                        shown={shown}
                        frozenFields={frozenFields}
                      />
                    ))}
          <LocalDiv>
            <Control alignCenter gap="10px">
              <AdjustIcon>
                <AddIcon />
              </AdjustIcon>
              <Text>
                {updatedList?.some(item => 
                      (item?.level === 'twelfth' || item?.label === 'Diploma')
                ) 
                  ? "Add Education" 
                  : "12th or Diploma *"}
              </Text>
            </Control>
          </LocalDiv>
          <SelectLocalWrapper
            getPopupContainer={() => document.body}
            key={refreshKey}
            onChange={(e, option) => subjectHandler(e, option)}
          >
            {updatedList?.some(item => 
                (item?.level === 'twelfth' || item?.label === 'Diploma')
            ) 
              ? educationDetails?.map((data, index) => {
                  let valueData = getEducationLevelValue(data?.value, false, [])
                  return (
                    <Option
                      value={valueData}
                      key={index + 'data'}
                      label={getEducationLevelLabel(data?.value)}
                    >
                      <OptionWrapper alignCenter isAdded={getAddedLevel(valueData)}>
                        {data?.label}
                      </OptionWrapper>
                    </Option>
                  )
                })
              : educationDetailsBefore?.map((data, index) => {
                  let valueData = getEducationLevelValue(data?.value, false, [])
                  return (
                    <Option
                      value={valueData}
                      key={index + 'data'}
                      label={getEducationLevelLabel(data?.value)}
                    >
                      <OptionWrapper alignCenter isAdded={getAddedLevel(valueData)}>
                        {data?.label}
                      </OptionWrapper>
                    </Option>
                  )
                })
            }
          </SelectLocalWrapper>

          <Control width="100%" flexEnd gap="15px">
            <Button.Secondary
              text="Back"
              onClick={handleBackClick}
            />
            <Button.Primary
              text="Save & Continue"
              htmlType={'submit'}
              onClick={submitHandler}
              disable={submitLoading}
            />
          </Control>
        </Form>
      ) : (
        <Spin />
      )}
    </Fragment>
  )
}

export default Education
